<template>
  <div class="block block-rounded block-bordered">
    <div class="block-header block-header-default">
      <h3 class="block-title">List of created widgets</h3>
      <div class="block-options">
        <div class="block-options-item">
          <a class="btn btn-success" href="/widget-editor/0">
            <i class="fas fa-plus text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="block-content">
      <table class="table table-hover table-vcenter">
        <thead>
          <tr>
            <th class="text-center" style="width: 50px">#</th>
            <th>Name</th>
            <th class="d-none d-sm-table-cell">Created</th>
            <th class="d-none d-sm-table-cell">Status</th>
            <th class="text-center" style="width: 100px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in allWidgets.data" :key="key">
            <th class="text-center" scope="row">{{ key + 1 }}</th>
            <td class="font-w600">
               <editable-field 
               :id="item.id" 
               :myvalue="item.name" 
               table="widgets"
               column="name"
               :href="'/widgets/view/' + item.id"
               ></editable-field>




            </td>
            <td class="d-none d-sm-table-cell">
              <span>{{ item.created_at }}</span>
            </td>
            <td class="d-none d-sm-table-cell">
              <span class="badge badge-success">Published</span>
            </td>
            <td class="text-center">
              <div class="btn-group">
                <a
                  :href="'/widgets/view/' + item.id"
                  class="btn btn-sm btn-outline-secondary"
                  data-toggle="tooltip"
                  title="View"
                >
                  <i class="fa fa-eye"></i>
                </a>
                <a
                  :href="'/widget-editor/' + item.id"
                  class="btn btn-sm btn-outline-primary"
                  data-toggle="tooltip"
                  title="Edit"
                >
                  <i class="fa fa-pencil-alt"></i>
                </a>
                <a
                  class="btn btn-sm btn-outline-warning"
                  data-toggle="tooltip"
                  title="Save as draft"
                >
                  <i class="fas fa-archive"></i>
                </a>
                <a
                  v-if="item.delete"
                  tag="button"
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  data-toggle="tooltip"
                  title="Delete"
                  @click="deleteForm(item.id)"
                >
                  <i class="fa fa-times"></i>
                </a>
                <span
                  v-else
                  class="btn btn-sm btn-outline-danger"
                  data-toggle="tooltip"
                  title="Default Widget"
                >
                  <i class="fa fa-times"></i>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12 pb-3 pr-4">
        <div
          class="btn-group btn-group-lg float-right"
          role="group"
          aria-label="Large Horizontal Outline Primary"
        >
          <a
            v-if="currentPage !== 1"
            :href="'widgets?page=' + (currentPage - 1)"
          >
            <button type="button" class="btn btn-outline-info">
              <i class="fa fa-arrow-left"></i>
            </button>
          </a>
          <a href="javascript:void(0)">
            <button
              type="button"
              class="btn btn-outline-info ml-3 mr-3"
              disabled
            >
              {{ currentPage }}
            </button>
          </a>
          <a
            v-if="currentPage !== lastPage"
            :href="'widgets?page=' + (currentPage + 1)"
          >
            <button type="button" class="btn btn-outline-info">
              <i class="fa fa-arrow-right"></i>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EditableField from './EditableField.vue';
export default {
  name: "WidgetsList",
  components: { EditableField },
  data: () => {
    return {
      currentPage: 1,
      lastPage: 1,
    };
  },
  methods: {
    ...mapActions({
      getAllWidgets: "widgets/getAllWidgets",
      deleteById: "widgets/deleteById"
    }),
    deleteForm(id) {
      if (confirm("Do you really want to delete?")) {
        this.deleteById(id).then(() => {
          this.getAllWidgets().then(() => {});
        });
      }
    },

  },
  computed: mapState({
    allWidgets: state => state.widgets.AllWidgets
  }),
  mounted() {
    this.getAllWidgets().then(response => {
      this.currentPage = response.data.meta.current_page;
      this.lastPage = response.data.meta.last_page;
    });
  }
};
</script>

<style scoped></style>
